import React from 'react';
import { PopupActionBar, PopupContentWrapper } from '../../../../components';
import {
  NoMoneyGoBackButtonLink,
  NoMoneyPaymentRequestButtonLink,
  NoMoneyText,
  NoMoneyTitle,
} from './connected';

export const NoMoney = () => (
  <PopupContentWrapper>
    <NoMoneyTitle />
    <NoMoneyText />

    <PopupActionBar>
      <NoMoneyPaymentRequestButtonLink />
      <NoMoneyGoBackButtonLink />
    </PopupActionBar>
  </PopupContentWrapper>
);
